import { ListFieldList } from '@/entities/Inventory/TypeField/model/types'

const REFERENCE_FIELD_TYPE_NAMES = new Set([
  'one_to_one',
  'one_to_many',
  'many_to_one',
  'many_to_many',
])

/** Известные коды field_types (см. спеку object-relations). */
const FIELD_TYPE_ID_TO_NAME: Record<number, string> = {
  1: 'one_to_one',
  2: 'one_to_many',
  3: 'many_to_one',
  4: 'many_to_many',
  10: 'catalog',
  21: 'string',
  22: 'date',
  23: 'range',
  24: 'number',
  25: 'boolean',
  26: 'year',
  27: 'phone',
  28: 'email',
  30: 'interator_simple',
  31: 'computed',
  32: 'address',
}

/**
 * Возвращает имя типа поля по числовому коду field_type.
 */
export function fieldTypeNameFromId(fieldType: number): string {
  return FIELD_TYPE_ID_TO_NAME[fieldType] ?? 'string'
}

/**
 * Переводит имя типа из нормализованной модели в legacy-type виджетов паспорта.
 */
export function fieldTypeNameToLegacyType(typeName: string): string {
  if (typeName === 'catalog') return ListFieldList.LIST_TYPES
  if (REFERENCE_FIELD_TYPE_NAMES.has(typeName)) return 'link_object'
  if (typeName === 'iterator') return 'interator_simple'
  return typeName
}
